import api from './api';
import { Notification, NotificationModule, NotificationLevel } from '../types';

interface NotificationFilters {
  centerId?: string;
  module?: NotificationModule;
  level?: NotificationLevel;
  isRead?: boolean;
  page?: number;
  limit?: number;
}

interface NotificationResponse {
  notifications: Notification[];
  total: number;
  page: number;
  totalPages: number;
}

export const notificationService = {
  // Get notifications with filters
  async getNotifications(filters: NotificationFilters = {}): Promise<NotificationResponse> {
    const params = new URLSearchParams();
    
    if (filters.centerId) params.append('centerId', filters.centerId);
    if (filters.module) params.append('module', filters.module);
    if (filters.level) params.append('level', filters.level);
    if (filters.isRead !== undefined) params.append('isRead', filters.isRead.toString());
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());

    const response = await api.get(`/notifications?${params.toString()}`);
    return response.data.data;
  },

  // Get unread count
  async getUnreadCount(): Promise<number> {
    const response = await api.get('/notifications/unread-count');
    return response.data.data.count;
  },

  // Mark notification as read
  async markAsRead(notificationId: string): Promise<Notification> {
    const response = await api.patch(`/notifications/${notificationId}/read`);
    return response.data.data;
  },

  // Mark all notifications as read
  async markAllAsRead(): Promise<{ count: number }> {
    const response = await api.patch('/notifications/mark-all-read');
    return response.data.data;
  }
};